export default __webpack_public_path__ + "static/media/sentencesinput_locked.9d372c76.svg";